import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { chatSelector, usersSelector } from 'src/selectors'
import MessageInner from './MessageInner/MessageInner'
import ViewMessageContext from './ViewMessageContext'
import SvgIcon from 'src/components/common/SvgIcon'
import LeftChevron from 'src/assets/icons/left_chevron.svg'
import { Image, Drawer } from 'antd'
import debounce from 'lodash/debounce'
import CloseIcon from 'assets/icons/close-icon.png'
import InputMessage from '../InputMessage/InputMessage'

import styles from './view-message.scss'

const ViewMessage = () => {
  const users = useSelector(state => usersSelector(state))
  const { messageList, chatMessages } = useSelector(chatSelector)

  const [previewGalleries, setPreviewGalleries] = useState([])
  const [previewIndex, setPreviewIndex] = useState(0)
  const [currentMessage, setCurrentMessage] = useState(null)

  const messagesRef = useRef(null)
  const messagesCountRef = useRef(0)
  const replyMessageRef = useRef(null)
  const replyMessageCountRef = useRef(0)

  useEffect(() => {
    const replyMessage = chatMessages[currentMessage?.id]
    if (
      replyMessageRef.current &&
      replyMessage &&
      replyMessage.replies.length > replyMessageCountRef.current
    ) {
      replyMessageRef.current.scrollTop = replyMessageRef.current.scrollHeight

      replyMessageCountRef.current = replyMessage.replies.length
    }
  })

  useEffect(() => {
    if (messagesRef.current && messageList.length > messagesCountRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight
    }

    messagesCountRef.current = messageList.length
  }, [messageList.length])

  const handleScroll = debounce(() => {
    console.log('scrolling')
  }, 300)

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (messagesRef.current) {
        messagesRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [handleScroll])

  const renderReplyMessage = () => {
    const messageBody = chatMessages[currentMessage.id]
    if (messageBody.destroyed_at) {
      setCurrentMessage(null)
      return
    }

    return (
      <div className={styles['reply-message-drawer']}>
        <div className={styles['reply-message-body']} ref={replyMessageRef}>
          <MessageInner
            inReply
            key={currentMessage.id}
            message={messageBody}
            user={users[currentMessage.user_id]}
          />
        </div>
        <InputMessage inReply message={currentMessage} />
      </div>
    )
  }

  return (
    <ViewMessageContext.Provider
      value={{
        onSetPreviewGalleries: setPreviewGalleries,
        onSetPreviewIndex: setPreviewIndex,
        onSetCurrentMessage: setCurrentMessage
      }}
    >
      <div className={styles['view-message-container']}>
        <div className={styles['header']}>
          <SvgIcon
            icon={LeftChevron}
            className={styles['left-icon']}
            onClick={() => history.back()}
          />
          <div className={styles['title']}># Group Chat</div>
        </div>

        <div className={styles['message-content']} ref={messagesRef}>
          {messageList.map(message => {
            const user = users[message.user_id]
            return <MessageInner key={message.id} message={message} user={user} />
          })}
        </div>
      </div>

      <div style={{ display: 'none' }}>
        <Image.PreviewGroup
          preview={{
            visible: Boolean(previewGalleries.length),
            onVisibleChange: () => setPreviewGalleries([]),
            current: previewIndex
          }}
        >
          {previewGalleries.map(img => (
            <Image key={img.id} src={img.image_upload.large_url} />
          ))}
        </Image.PreviewGroup>
      </div>

      <Drawer
        open={Boolean(currentMessage)}
        closable={false}
        mask={false}
        destroyOnClose
        drawerStyle={{ backgroundColor: '#f9f9f9' }}
        className={styles['drawer-container']}
        title={
          <div className={styles['drawer-title']}>
            <span className={styles['title']}>Thread</span>
            <img src={CloseIcon} width={20} onClick={() => setCurrentMessage(null)} />
          </div>
        }
      >
        {currentMessage && renderReplyMessage()}
      </Drawer>
    </ViewMessageContext.Provider>
  )
}

export default ViewMessage
